import type { ReactNode } from 'react'
import styles from './PageHeader.module.css'

/** The shared masthead every inner page opens with. */
export function PageHeader({
  eyebrow,
  title,
  lede,
  children,
}: {
  eyebrow?: string
  title: string
  lede?: string
  children?: ReactNode
}) {
  return (
    <header className={styles.header}>
      {eyebrow && <p className={styles.eyebrow}>{eyebrow}</p>}
      <h1 className={styles.title}>{title}</h1>
      {lede && <p className={styles.lede}>{lede}</p>}
      {children && <div className={styles.extra}>{children}</div>}
    </header>
  )
}
